import DefaultLayout from '../layout/DefaultLayout';
import Breadcrumb from '../components/Breadcrumbs/Breadcrumb.tsx';
import ProtocolsTable from '../components/Protocols/ProtocolsTable.tsx';


const Protocols = () => {
    return (
        <DefaultLayout>
            <Breadcrumb pageName="Protocols" />
            <ProtocolsTable/>
        </DefaultLayout>
    );
};

export default Protocols;
